<template class="full-heigth">
  <div class="full-heigth agency-set-main">
    <el-dialog title="領隊資料維護" :visible.sync="dialogLeaderFormVisible">
      <div>
        <leader-data :agency-code="leaderAgecnyCode" />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="danger" @click="dialogLeaderFormVisible = false">關 閉</el-button>
      </div>
    </el-dialog>

    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>{{ userInfo.agencyName }}</span>
        <!-- <el-button style="float: right; padding: 3px 0" type="text"
          >操作按钮</el-button
        > -->
      </div>
      <div>
        <no-auth v-if="!userInfo.agencyCode"></no-auth>
        <el-form
          v-if="userInfo.agencyCode"
          ref="dynamicValidateForm"
          v-loading="formLoading"
          :model="formData"
          style="position: relative"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item
                label="旅行社代碼"
                :label-width="formLabelWidth"
                prop="agencyCode"
                :rules="[
                  {
                    required: true,
                    message: '請輸入旅行社代碼',
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input v-model="formData.agencyCode" readonly autocomplete="off" />
              </el-form-item>

              <el-form-item
                label="旅行社名稱"
                :label-width="formLabelWidth"
                prop="agencyName"
                :rules="[
                  {
                    required: true,
                    message: '請輸入旅行社名稱',
                    trigger: 'change',
                  },
                ]"
              >
                <el-input v-model="formData.agencyName" autocomplete="off" />
              </el-form-item>

              <el-form-item
                label="旅行社簡稱"
                :label-width="formLabelWidth"
                prop="agencyShortName"
                :rules="[
                  {
                    required: true,
                    message: '請輸入旅行社簡稱',
                    trigger: 'change',
                  },
                ]"
              >
                <el-input v-model="formData.agencyShortName" autocomplete="off" />
              </el-form-item>

              <el-row>
                <el-col :span="12">
                  <el-form-item
                    label="統一編號"
                    :label-width="formLabelWidth"
                    prop="vatNumber"
                    :rules="[
                      {
                        required: true,
                        message: '請輸入統一編號',
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input v-model="formData.vatNumber" autocomplete="off" />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="負責人"
                    :label-width="formLabelWidth"
                    prop="boss"
                    :rules="[
                      {
                        required: true,
                        message: '請輸入負責人',
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input v-model="formData.boss" autocomplete="off" />
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- <el-form-item label="統一編號" :label-width="formLabelWidth">
                <label
                  for="vatNumber"
                  class="el-form-item__label"
                  style="position: absolute; left: -78px; color: red"
                  >*</label
                >
                <el-row class="vatnumber-boss">
                  <el-col :span="12">
                    <el-form-item
                      :label-width="formLabelWidth"
                      prop="vatNumber"
                      :rules="[
                        {
                          required: true,
                          message: '請輸入統一編號',
                          trigger: 'blur',
                        },
                      ]"
                    >
                      <el-input
                        style="left: -119px; width: 100%"
                        v-model="formData.vatNumber"
                        autocomplete="off"
                      /> </el-form-item
                  ></el-col>
                  <el-col :span="12">
                    <el-form-item
                      style="position: relative; left: -12px"
                      label="負責人"
                      :label-width="formLabelWidth"
                      prop="boss"
                      :rules="[
                        {
                          required: true,
                          message: '請輸負責人',
                          trigger: 'blur',
                        },
                      ]"
                    >
                      <el-input
                        style="width: 100%"
                        v-model="formData.boss"
                        autocomplete="off"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form-item> -->

              <el-form-item
                label="Email"
                :label-width="formLabelWidth"
                prop="email"
                :rules="[
                  {
                    required: true,
                    message: '請輸入Email',
                    trigger: 'blur',
                  },
                  {
                    required: true,
                    pattern: pattern.email,
                    message: 'Email格式不正確',
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input v-model="formData.email" autocomplete="off" />
              </el-form-item>

              <el-form-item
                label="電話"
                :label-width="formLabelWidth"
                prop="tel"
                :rules="[{ required: true, message: '請輸入電話', trigger: 'blur' }]"
              >
                <el-input v-model="formData.tel" autocomplete="off" />
              </el-form-item>

              <el-form-item
                label="地址"
                :label-width="formLabelWidth"
                prop="addr"
                :rules="[{ required: true, message: '請輸地址', trigger: 'blur' }]"
              >
                <el-row style="margin-bottom: 22px">
                  <el-col :span="24" style="display: flex; align-items: center">
                    <el-form-item>
                      <!-- <input
                        :readonly="true"
                        type="text"
                        v-model="zipCode"
                        style="width: 70px; margin: 12px; color: red"
                      /> -->
                      <el-input
                        class="zipCode"
                        v-model="zipCode"
                        autocomplete="off"
                        :readonly="true"
                        style="width: 95%"
                      />
                    </el-form-item>
                    <el-form-item
                      prop="city"
                      :rules="[
                        {
                          required: true,
                          message: '請選擇縣市',
                          trigger: 'change',
                        },
                      ]"
                    >
                      <el-select
                        @change="getTaiwanCitiesOption(2, true)"
                        v-model="formData.city"
                        style="width: 95%"
                        filterable
                        clearable
                        placeholder="請選擇縣市"
                      >
                        <el-option
                          v-for="item in twCityOptions"
                          :key="item"
                          :label="item"
                          :value="item"
                        />
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      prop="site"
                      :rules="[
                        {
                          required: true,
                          message: '請選擇行政區域',
                          trigger: 'change',
                        },
                      ]"
                    >
                      <el-select
                        @change="getTaiwanCitiesOption(3, true)"
                        v-model="formData.site"
                        style="width: 95%"
                        filterable
                        clearable
                        placeholder="請選擇行政區域"
                      >
                        <el-option
                          v-for="item in twSiteOptions"
                          :key="item"
                          :label="item"
                          :value="item"
                        />
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      prop="road"
                      :rules="[
                        {
                          required: true,
                          message: '請選擇路名',
                          trigger: 'change',
                        },
                      ]"
                    >
                      <el-select
                        @change="getTaiwanCitiesZipCode"
                        v-model="formData.road"
                        style="width: 100%"
                        filterable
                        clearable
                        placeholder="請選擇路名"
                      >
                        <el-option
                          v-for="item in twRoadOptions"
                          :key="item"
                          :label="item"
                          :value="item"
                        />
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-form-item>
                    <el-input v-model="formData.addr" autocomplete="off" />
                  </el-form-item>
                </el-row>
              </el-form-item>

              <el-form-item
                label="付款日"
                :label-width="formLabelWidth"
                prop="paymentDate"
                :rules="[
                  {
                    required: true,
                    message: '請選擇付款日',
                    trigger: 'change',
                  },
                ]"
              >
                <el-select
                  :disabled="true"
                  style="margin: 5px; width: 50%"
                  v-model="formData.paymentDate"
                  filterable
                  clearable
                  placeholder="請選擇付款日"
                >
                  <el-option
                    v-for="item in checkOutDates"
                    :key="item"
                    :label="item"
                    :value="item"
                  />
                </el-select>
                日
              </el-form-item>

              <el-form-item
                label="結帳日"
                :label-width="formLabelWidth"
                prop="checkOutDate"
                :rules="[
                  {
                    required: true,
                    message: '請選擇結帳日',
                    trigger: 'change',
                  },
                ]"
              >
                <el-select
                  :disabled="true"
                  style="margin: 5px; width: 50%"
                  v-model="formData.checkOutDate"
                  filterable
                  clearable
                  placeholder="請選擇結帳日"
                >
                  <el-option
                    v-for="item in checkOutDates"
                    :key="item"
                    :label="item"
                    :value="item"
                  />
                </el-select>
                日
              </el-form-item>

              <el-form-item label="代表圖" :label-width="formLabelWidth">
                <el-row>
                  <!-- <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                    <el-tag
                      type="warning"
                      style="
                        height: auto;
                        white-space: break-spaces;
                        font-size: 14px;
                        margin: 5px;
                      "
                      >請上傳正方形圖片以利APP呈現，圖片須為.jpg,.jpeg,.png格式</el-tag
                    >
                  </el-col> -->

                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                    <div style="position: relative; margin-left: 5px; height: 100px">
                      <Upload
                        class="agency-logo"
                        ref="uploadRef"
                        :payload="formData"
                        :limitText="'請上傳正方形圖片以利APP呈現，圖片須為.jpg,.jpeg,.png格式，限制不超過2000MB'"
                        :accept="'.jpg,.jpeg,.png'"
                        :data-obj="fileObj"
                        :use-drag="false"
                        :action="'Agency/saveAgency'"
                        :auto-upload="false"
                        :show-file-list="true"
                        :form-on-loading-parent="formLoading"
                        :btn-txt="'上傳'"
                        :before-file-list="
                          formData.fileInfo && formData.fileInfo.length
                            ? formData.fileInfo[0].files
                            : []
                        "
                      />
                    </div>
                  </el-col>
                </el-row>
              </el-form-item>
              <!-- <el-form-item label="領隊維護" :label-width="formLabelWidth">
                <el-button
                  type="warning"
                  size="mini"
                  @click="editLeaderInfoData()"
                  >領隊維護</el-button
                >
              </el-form-item> -->
            </el-col>
            <el-col :span="12">
              <el-form-item label="網站連結" :label-width="formLabelWidth" prop="bulletinBoard">
                <div>
                  <!-- <el-alert
                    title="若建立旅遊團會自動帶入以下社群連結，並於該旅遊團【編輯】內可改變連結以及決定是否顯示於App。"
                    type="warning"
                    :closable="false"
                    style="width: 100%"
                  >
                  </el-alert> -->
                  <el-tag
                    type="warning"
                    style="height: auto; white-space: break-spaces; font-size: 14px; margin: 5px"
                    >若建立旅遊團會自動帶入以下社群連結，並於該旅遊團【編輯】內可改變連結以及決定是否顯示於App</el-tag
                  >
                  <el-row>
                    <el-col :span="19">
                      <el-input
                        class="web-link"
                        placeholder="請輸入官網連結"
                        v-model="formData.official"
                      >
                        <template slot="prepend">
                          <a :href="formData.official" target="_blank">
                            <svg-icon icon-class="soical_Icon" />
                          </a>
                        </template>
                        <i
                          class="el-icon-view el-input__icon"
                          style="cursor: pointer"
                          v-if="!!formData.official"
                          slot="suffix"
                          @click="handleView(formData.official)"
                        >
                        </i>
                      </el-input>
                    </el-col>
                  </el-row>
                </div>

                <div>
                  <el-row>
                    <el-col :span="19">
                      <el-input
                        class="web-link"
                        placeholder="請輸入Line官方帳號連結"
                        v-model="formData.line"
                      >
                        <template slot="prepend">
                          <svg-icon icon-class="ic_line" />
                        </template>
                        <i
                          class="el-icon-view el-input__icon"
                          style="cursor: pointer"
                          v-if="!!formData.line"
                          slot="suffix"
                          @click="handleView(formData.line)"
                        >
                        </i>
                      </el-input>
                    </el-col>
                  </el-row>
                </div>

                <div>
                  <el-row>
                    <el-col :span="19">
                      <el-input
                        class="web-link"
                        placeholder="請輸入FB粉絲團連結"
                        v-model="formData.fb"
                      >
                        <template slot="prepend">
                          <svg-icon icon-class="ic_facebook" />
                        </template>
                        <i
                          class="el-icon-view el-input__icon"
                          style="cursor: pointer"
                          v-if="!!formData.fb"
                          slot="suffix"
                          @click="handleView(formData.fb)"
                        >
                        </i>
                      </el-input>
                    </el-col>
                  </el-row>
                </div>

                <div>
                  <el-row>
                    <el-col :span="19">
                      <el-input class="web-link" placeholder="請輸入IG連結" v-model="formData.ig">
                        <template slot="prepend">
                          <svg-icon icon-class="ic_ig" />
                        </template>
                        <i
                          class="el-icon-view el-input__icon"
                          style="cursor: pointer"
                          v-if="!!formData.ig"
                          slot="suffix"
                          @click="handleView(formData.ig)"
                        >
                        </i>
                      </el-input>
                    </el-col>
                  </el-row>
                </div>
                <div>
                  <el-row>
                    <el-col :span="19">
                      <el-input
                        class="web-link"
                        placeholder="請輸入Youtube連結"
                        v-model="formData.yt"
                      >
                        <template slot="prepend">
                          <svg-icon icon-class="ic_youtube" />
                        </template>
                        <i
                          class="el-icon-view el-input__icon"
                          style="cursor: pointer"
                          v-if="!!formData.yt"
                          slot="suffix"
                          @click="handleView(formData.yt)"
                        >
                        </i>
                      </el-input>
                    </el-col>
                  </el-row>
                </div>
              </el-form-item>
              <!-- <el-form-item> </el-form-item>
              <el-form-item> </el-form-item>
              <el-form-item> </el-form-item>
              <el-form-item> </el-form-item>
              <el-form-item> </el-form-item>
              <el-form-item> </el-form-item>
              <el-form-item> </el-form-item>
              <el-form-item> </el-form-item>
              <el-form-item> </el-form-item>
              <el-form-item> </el-form-item>
              <el-form-item> </el-form-item>
              <el-form-item> </el-form-item>
              <el-form-item> </el-form-item>
              <el-form-item> </el-form-item>
              <el-form-item> </el-form-item> -->
              <!-- <el-form-item
                label="存檔"
                :label-width="formLabelWidth"
                style="border: 1px solid #ccc; padding: 5px; width: 40%"
              >
                <el-button
                  type="success"
                  size="mini"
                  @click="saveData('dynamicValidateForm')"
                  >儲 存</el-button
                >
              </el-form-item> -->
            </el-col>
          </el-row>
          <div style="position: absolute; right: 10px; bottom: 10px">
            <el-button
              type="warning"
              @click="saveData('dynamicValidateForm')"
              style="color: #4b4b4b"
              >儲 存</el-button
            >
          </div>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import {
  getAnAgencyByCode,
  saveAgency,
  getTaiwanCitiesOption,
  getTaiwanCitiesZipCode,
} from '@/api/agency'
import { MessageBox, Message } from 'element-ui'
import { mapGetters } from 'vuex'

var defaultForm = {
  id: null,
  fileInfo: {},
  checkOutDate: null,
  paymentDate: null,
  city: null,
  site: null,
  road: null,
  addr: null,
}

export default {
  name: 'AgencyInfo',
  components: {
    leaderData: () => import('@/views/ita/components/leaderData.vue'),
    Upload: () => import('@/views/ita/components/fileUpload.vue'),
    noAuth: () => import('@/views/error-page/401'),
  },
  props: {
    // code: {
    //   type: String,
    //   default: null,
    // },
  },
  async activated() {
    if (this.userInfo.agencyCode) {
      await this.getAnAgencyByCode()
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  data() {
    return {
      pattern: {
        email:
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      },
      zipCode: null,
      dialogLeaderFormVisible: false,
      formLoading: false,
      fileObj: { id: 0, type: 'agencyInfo', user: '' },
      leaderAgecnyCode: '',
      isAdd: true,
      formLabelWidth: '120px',
      formData: defaultForm,
      leaderFormData: { id: null },
      checkOutDates: [],
      twCityOptions: [],
      twSiteOptions: [],
      twRoadOptions: [],
    }
  },
  async created() {
    await this.getTaiwanCitiesOption(1, true)
    if (this.userInfo.agencyCode) {
      await this.getAnAgencyByCode()
      await this.getTaiwanCitiesOption(2, false)
    }

    for (let i = 1; i <= 31; i++) {
      this.checkOutDates.push(i)
    }
  },
  methods: {
    async getTaiwanCitiesOption(filterType, bindDefault) {
      try {
        let resp
        switch (filterType) {
          case 1:
            resp = await getTaiwanCitiesOption({
              filterType,
              city: null,
              site: null,
            })
            this.twCityOptions = resp.data
            if (bindDefault) {
              this.formData.city = this.twCityOptions[0]
            }

            break
          case 2:
            resp = await getTaiwanCitiesOption({
              filterType,
              city: this.formData.city,
              site: null,
            })
            this.twSiteOptions = resp.data
            if (bindDefault) {
              this.formData.site = this.twSiteOptions[0]
            }
            this.getTaiwanCitiesOption(3, bindDefault)

            break
          case 3:
            resp = await getTaiwanCitiesOption({
              filterType,
              city: this.formData.city,
              site: this.formData.site,
            })
            this.twRoadOptions = resp.data
            if (bindDefault) {
              this.formData.road = this.twRoadOptions[0]
            }
            await this.getTaiwanCitiesZipCode()

            break
          default:
            break
        }
      } catch (error) {
        console.log(error)
      } finally {
      }
    },
    async getTaiwanCitiesZipCode() {
      let resp = await getTaiwanCitiesZipCode({
        city: this.formData.city,
        site: this.formData.site,
        road: this.formData.road,
      })
      this.zipCode = resp.data
    },
    async getAnAgencyByCode() {
      this.formLoading = true
      let refUpload = this.$refs['uploadRef']
      if (refUpload) {
        refUpload.clearFiles()
      }
      let resp = await getAnAgencyByCode({ code: this.userInfo.agencyCode })

      this.formData = resp.data
      this.formLoading = false
    },
    async saveData(formName) {
      const vm = this
      if (!confirm(`確定要儲存${vm.formData.agencyName}資料?`)) {
        return false
      }

      let webLinksDesc = {
        official: '官網',
        fb: 'FB',
        line: 'Line',
        ig: 'IG',
      }

      let validateWebSet = true
      Object.keys(webLinksDesc).forEach(keys => {
        let desc = webLinksDesc[keys]
        if (validateWebSet && vm.formData[keys]) {
          let expression =
            /http|https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
          let regex = new RegExp(expression)
          let t = vm.formData[keys]
          if (!t.match(regex)) {
            vm.$message.error(`【${desc}】連結不是有效連結。`)
            validateWebSet = false
            return false
          }
        }
      })

      if (!validateWebSet) {
        return
      }
      //$refs["uploadRef"] 不能放在 $refs[formName]的敘述裡面建立，組件裡面會找不到refs.upload
      let refUpload = this.$refs['uploadRef']
      this.$refs[formName].validate(async valid => {
        if (valid) {
          vm.formLoading = true
          let payload = await refUpload.combineFileAndPayload()
          if (!payload) {
            alert('檔案繫結表單發生未知錯誤，無法儲存資料。')
            return false
          }
          let formatData = payload
          let res = await saveAgency(payload)
          refUpload.clearFiles()
          vm.dialogFormVisible = false
          vm.formLoading = false
          await vm.getAnAgencyByCode()

          Message({
            message: '資料處理完成',
            type: 'success',
            duration: 5 * 1000,
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    onDialogClosed() {
      let refUpload = this.$refs['uploadRef']
      refUpload.clearFiles()
    },
    editData(d) {
      const vm = this
      vm.isAdd = false
      vm.formData = d
      vm.dialogFormVisible = true
    },
    editLeaderInfoData() {
      const vm = this
      vm.dialogLeaderFormVisible = true
      vm.leaderAgecnyCode = ''
      setTimeout(() => {
        vm.leaderAgecnyCode = vm.userInfo.agencyCode
      }, 400)
    },
    handleView(url) {
      if (!!url) {
        window.open(url, '_blank')
      }
    },
  },
}
</script>
<style>
.full-heigth {
  position: relative;
  height: 100%;
  padding: 15px;
}

.agency-set-main .svg-icon {
  width: 2em !important;
  height: 2em !important;
}

.web-link {
  margin: 5px;
}

.el-form-item__error {
  z-index: 500;
}

.agency-logo .el-upload-list {
  position: absolute;
  user-select: auto;
  top: 0;
  left: 60px;
}

.el-upload-list__item:first-child {
  margin-top: 5px;
}

.vatnumber-boss .el-form-item__content {
  width: 70%;
}

.zipCode .el-input__inner {
  color: red;
}
</style>
